<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {

};
</script>
<style lang="less">
html,
body {
  margin: 0;
  padding: 0;
  // background-color: #0962f2;
  // background: radial-gradient(ellipse at bottom, #1b2735 0%, #090a0f 100%);
  min-height: 100vh;
  background: #fdf8ed;
  overflow-x: hidden;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #ffffff;
  position: relative;
  // background-color: #0962f2;
  // background: url("./assets/bg.png") no-repeat top left;
  background-size: 100% 100%;
  position: relative;
}
.ymf-text{
  min-height: 0px;
  position: fixed;
  left: -9999px;
  top: -9999px;
}
.md-container {
  width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
  height: 100%;
  p,
  pre {
    margin: 0;
    padding: 0;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
    padding: 0;
  }
}
a {
  outline: none;
  text-decoration: none;
}
img {
  max-width: 100%;
  max-height: 100%;
  vertical-align: top;
}
// @font-face {
//   font-family: "hanli";
//   src: url(https://ymf-cross-resource.oss-cn-hangzhou.aliyuncs.com/HanliOldstyle.woff) format("woff");
//   font-display: swap;
// }
@font-face {
  font-family: "hanli-min";
  src: url(https://ymf-cross-resource.oss-cn-hangzhou.aliyuncs.com/HanliOldstyle-min.woff) format("woff");
  font-display: swap;
}
@font-face {
  font-family: "Hl0628";
  src: url(https://ymf-cross-resource.oss-cn-hangzhou.aliyuncs.com/HanliOldstyle1751093715560.woff) format("woff");
  font-display: swap;
}
@font-face {
  font-family: "Hl0811";
  src: url(https://ymf-cross-resource.oss-cn-hangzhou.aliyuncs.com/HanliOldstyle1754899548024.woff) format("woff");
  font-display: swap;
}
@font-face {
  font-family: "Hl1126";
  src: url(https://ymf-cross-resource.oss-cn-hangzhou.aliyuncs.com/HanliOldstyle1764170617209.woff) format("woff");
  font-display: swap;
}


@font-face {
  font-family: "Hl0906";
  src: url(https://ymf-cross-resource.oss-cn-hangzhou.aliyuncs.com/HanliOldstyle1757141294641.woff) format("woff");
  font-display: swap;
}

@font-face {
  font-family: "en";
  src: url(https://ymf-cross-resource.oss-cn-hangzhou.aliyuncs.com/A602.woff) format("woff");
  font-display: swap;
}

@font-face {
  font-family: "ming-min";
  src: url(https://ymf-cross-resource.oss-cn-hangzhou.aliyuncs.com/Ming-min.woff) format("woff");
  font-display: swap;
}
@media(max-width: 1200px) {
  div.focus-wrapper{
    height: 65.067vw !important;
  }
  span.focus-logo{
   display: none;
  }
  span.focus-title{
    width: 26.133vw !important;
    height: 32.9333vw !important;
    top: 7.2vw !important;
    transform: translateX(-50%);
    background: url(https://outin-659b005a2fad11f083ad00163e1c94a4.oss-cn-shanghai.aliyuncs.com/image/default/939AB67E9C9440228DC5A684A2021C40-6-2.png) no-repeat top center;
    background-size: 100% auto;
  }
}
.focus-title {
  position: absolute;
  background: url(https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/focus-title.png) no-repeat top center;
  background-size: 100% auto;
  width: 288px;
  height: 508px;
  left: 50%;
  transform: translateX(-50%);
  top: 58px;
}
.focus-logo{
  position: absolute;
  background: url(https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/title_b.png) no-repeat top center;
  width: 333px;
  height: 59px;
  background-size: 100% auto;
  left: 100px;
  top: 68px;
}
// @font-face {
//   font-family: "ming";
//   src: url(../public/font/Ming.otf) format("truetype");
// }
// @font-face {
//   font-family: "type-writer";
//   src: url(../public/font/A602.ttf) format("truetype");
// }
// @font-face {
//   font-family: "roman";
//   src: url(../public/font/Roman.otf) format("truetype");
// }

</style>
